import styles from "./index.module.css";
import { useContext, useState } from "react";
import UserContext from "../../../store/UserStore/context";
import getLevelInfo from "../helpers";
import { programs } from "../enums";
import Down from "./down";

export default function Topics() {
  const userStore = useContext(UserContext);

  const score = userStore.store.user.testResult;

  const { key } = getLevelInfo(score);
  const data = programs[key];
  if (!data) return null;

  return (
    <div className={styles.container}>
      <h1>
        ТЕМИ
        <br /> ІНТЕНСИВУ
      </h1>

      {data.grammar && data.grammar.length ? (
        <TopicBlock data={data.grammar} title="Grammar" />
      ) : null}

      {data.vocabulary && data.vocabulary.length ? (
        <TopicBlock data={data.vocabulary} title="Vocabulary" />
      ) : null}

      {data.speaking && data.speaking.length ? (
        <TopicBlock data={data.speaking} title="Speaking" />
      ) : null}

      {data.functionalLanguage && data.functionalLanguage.length ? (
        <TopicBlock
          data={data.functionalLanguage}
          title="Functional language"
        />
      ) : null}

      {data.review && data.review.length ? (
        <TopicBlock data={data.review} title="Review" />
      ) : null}
    </div>
  );
}

function TopicBlock({ data, title }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.topicBlock + (open ? " " + styles.open : "")}>
      <div className={styles.header} onClick={() => setOpen(!open)}>
        <h3>{title}</h3>
        <Down />
      </div>
      <ul className={styles.list}>
        {data.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
}
